import { useState, useEffect } from 'react';
import apiClient from '../api/client';

export const useApiKey = () => {
  const [apiKey, setApiKey] = useState('');
  const [isSet, setIsSet] = useState(false);
  const [lastUpdated, setLastUpdated] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // Fetch API key
  const fetchApiKey = async () => {
    try {
      setIsLoading(true);
      setError(null);
      
      const token = localStorage.getItem('auth_token');
      const response = await apiClient.get('/settings/api-key', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      
      setApiKey(response.data.api_key);
      setIsSet(response.data.is_set);
      setLastUpdated(response.data.last_updated);
    } catch (err) {
      console.error('Error fetching API key:', err);
      setError(err.response?.data?.detail || 'Failed to fetch API key');
    } finally {
      setIsLoading(false);
    }
  };

  // Update API key
  const updateApiKey = async (newApiKey) => {
    try {
      setIsLoading(true);
      setError(null);
      
      const token = localStorage.getItem('auth_token');
      await apiClient.patch('/settings/api-key', 
        { api_key: newApiKey },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      
      // Refresh the API key data
      await fetchApiKey();
      return true;
    } catch (err) {
      console.error('Error updating API key:', err);
      setError(err.response?.data?.detail || 'Failed to update API key');
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  // Copy API key to clipboard
  const copyApiKey = async () => {
    try {
      await navigator.clipboard.writeText(apiKey);
      return true;
    } catch (err) {
      console.error('Error copying to clipboard:', err);
      return false;
    }
  };

  // Load API key on mount
  useEffect(() => {
    fetchApiKey();
  }, []);

  return {
    apiKey,
    isSet,
    lastUpdated,
    isLoading,
    error,
    fetchApiKey,
    updateApiKey,
    copyApiKey,
  };
}; 